export const HEADER = "HEADER"
export const FOOTER = "FOOTER"
export const MOBILE = "MOBILE"
export const DESKTOP = "DESKTOP"

// Redux Actions
export const UPDATE_PAGE_URI = "UPDATE_PAGE"
export const UPDATE_RESPONSIVE_MODE = "UPDATE_RESPONSIVE_MODE"
export const UPDATE_MOBILE_MENU_MODE = "UPDATE_MOBILE_MENU_MODE"
